import React from 'react';
import { Trans } from 'react-i18next';
import { RM3_RIBBON } from 'arbitrip-common/client/utils/HotelDealsRm3';

export const RIBBON_I18N_SUFFIX = Object.freeze({
    [RM3_RIBBON.LOW]: 'Low',
    [RM3_RIBBON.VALUE]: 'Value',
    [RM3_RIBBON.TERMS]: 'Terms',
    [RM3_RIBBON.FC]: 'Fc',
});

/** Spec §3.4 / §7: one ribbon per deal, fixed colours (CSS custom properties set on the section root), no tooltip. */
function Rm3Ribbon({ kind }) {
    if (!RIBBON_I18N_SUFFIX[kind]) {
        return null;
    }
    const tone = kind === RM3_RIBBON.LOW ? 'rm3-ribbon--low' : 'rm3-ribbon--best';
    return (
        <span className={`rm3-ribbon ${tone}`} data-testid="rm3-deal-ribbon" data-ribbon={kind}>
            <span>
                <Trans
                    i18nKey={`HotelDealsRm3.Ribbon.${RIBBON_I18N_SUFFIX[kind]}`}
                    components={{ strong: <strong /> }}
                />
            </span>
            <span className="rm3-ribbon__fold" aria-hidden="true" />
        </span>
    );
}

export default Rm3Ribbon;
